import Location from 'react-app-location';

export const PersonalDataLocation = new Location('/personal-data');
